export default "__VITE_ASSET__Dp7QZDUq__"